import React from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import { FeatureCardProps } from "@/components/Chat/FeatureCards";

interface ShortcutDisplayProps {
  shortcut: FeatureCardProps;
}

export const ShortcutDisplay: React.FC<ShortcutDisplayProps> = ({ shortcut }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex items-center gap-2">
        {shortcut.icon && (
          <Icon className="text-primary" height={24} icon={shortcut.icon} width={24} />
        )}
        <p className="font-medium text-lg">{shortcut.title}</p>
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        {t("Key")}: {shortcut.key}
      </p>
      <div className="mt-2">
        <p className="text-sm font-medium">{t("Descriptions")}:</p>
        <ul className="list-disc list-inside text-sm text-gray-500 dark:text-gray-400">
          {shortcut.descriptions.map((desc, i) => (
            <li key={i}>{desc}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};
